import LearningResourceType from './LearningResourceType'

/**
 * 播放资源信息
 */
class VideoResource {
  /**
   * 媒体资源类型：
   * 0 - 800Li视频
   * 1 - 保利威视
   * 2 - 华为云
   * 20 - 华为云音频
   * 注意：800Li视频没有清晰度
   */
  resourceType: LearningResourceType
  /**
   * 媒体资源地址，.m3u8/.mp3/.mp4相对路径
   */
  url = ''
  /**
   * 清晰度
   */
  quality: number
}

export default VideoResource
